import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Form, Button} from "antd";
import {useTranslation} from "react-i18next";
import AuthBg from "../../components/background/AuthBg";
import {authActions, dataActions} from "_actions";
import {Steps} from "antd";

import "./center.scss";
import {history} from "../../_helpers";
import StepOneCenter from "./step/stepOne";
import StepTwoCenter from "./step/stepTwo";
import StepThreeCenter from "./step/stepThree";
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import variables from "../../_constants/variables";
import localOrSessionStore from "../../_helpers/localOrSessionStore";
import {xcService} from "../../_services/xcService";

const {Step} = Steps;

function RegisterCenter(props) {
  const dispatch = useDispatch();

  const storage = localOrSessionStore({key: variables.REMEMBER});
  const user = JSON.parse(storage.getItem(variables.USER));

  const [form] = Form.useForm();
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptlegal, setAcceptLegal] = useState(false);
  const [current, setCurrent] = useState(-1);
  const [courses, setCourses] = useState([]);

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [values, setValues] = useState(null);
  const [center, setCenter] = useState(null);

  var checkCodeCenter = useSelector((state) => state.authReducer.checkCodeCenter);
  var checkCodeCenterError = useSelector((state) => state.authReducer.checkCodeCenterError);
  var coursesData = useSelector((state) => state.dataReducer.coursesData);

  var actualYear = useSelector((state) => state.authReducer.actualYear);

  useEffect(() => {
    if (!actualYear) {
      dispatch(authActions.actualYear());
    }
  }, []);

  useEffect(() => {
    if (!coursesData) getCourses();

    xcService.get("/v1/tutor/contractemp/" + user.code).then((data) => {
    });
  }, []);

  const getCourses = () => {
    dispatch(dataActions.getCourses());
  };
  useEffect(() => {
    if (coursesData) setCourses(coursesData);
  }, [coursesData]);

  const onChange = (value) => {
    setCurrent(value);
    let scrollContainers = document.querySelectorAll(".is-scrollable");
    scrollContainers.forEach((cont) => (cont.scrollTop = 0));
  };

  const goTo = async (vals, number) => {
    setValues({...values, ...vals});

    if (number === 1) {
      xcService.post("/v1/tutor/contractemp/1", vals).then((data) => {
      });
    }
    if (number === 2) {
      let mData = vals;
      mData.code = user.code;

      xcService.post("/v1/tutor/contractemp/2", mData).then((data) => {
      });
    }

    setCurrent(number);
    let scrollContainers = document.querySelectorAll(".is-scrollable");
    scrollContainers.forEach((cont) => (cont.scrollTop = 0));
  };

  const saveCenter = (val) => {
    setCenter(val);
  };

  return (
    <>
      <div className="containerRowRegister">
        <NavbarNoLogin className="menuNavRegister" />

        <div className="colRegister leftRegister">
          <h1>{t("welcome")}</h1>
          <AuthBg />
        </div>

        <div className="colRegister rightRegister">
          <div className="headerMobile">
            <h1>{t("welcome")}</h1>
          </div>

          <div className="containerRegister">
            <div className="centerContract">
              {current === -1 ? (
                <>
                  <div className={"infoContract is-scrollable is-scrollable--center-first"}>
                    <h3>{t("registercenter.contrato")}</h3>

                    <p className={"small"}>
                      {t("registercenter.subcontrato")}{" "}
                      {"20" + (actualYear ? +actualYear : 22) + "/20" + (actualYear ? +actualYear + 1 : 23)}.
                    </p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html:
                          t("registercenter.subcontrato2byear") +
                          " 20" +
                          (actualYear ? +actualYear : 22) +
                          "/20" +
                          (actualYear ? +actualYear + 1 : 23) +
                          " " +
                          t("registercenter.subcontrato2ayear"),
                      }}
                    />

                    <p>{t("registercenter.subcontrato3")}</p>
                    <div style={{marginLeft: 15}}>
                      <h3>{t("registercenter.title1")}</h3>
                      <p>{t("registercenter.desctitle1")}</p>

                      <h3>{t("registercenter.title2")}</h3>
                      <p dangerouslySetInnerHTML={{__html: t("registercenter.desctitle2")}} />

                      <h3>{t("registercenter.title3")}</h3>
                      <p dangerouslySetInnerHTML={{__html: t("registercenter.desctitle3")}} />

                      <h3>{t("registercenter.title4")}</h3>
                      <p dangerouslySetInnerHTML={{__html: t("registercenter.desctitle4")}} />
                    </div>

                    <div style={{textAlign: "right"}}>
                      <Button onClick={() => setCurrent(0)} type={"primary"} className="primaryButton ">
                        {t("start")}
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {current < 3 && (
                    <>
                      <div data-id={'tab-register-parent'} className={"steps is-scrollable is-scrollable--center"}>
                        <h3>{t("registercenter.contrato")}</h3>
                        <p style={{marginBottom: 8}}>
                          {t("registercenter.cursoa")} {`20${actualYear}/20${+actualYear + 1}`} {/* TOD YEAR */}
                        </p>
                        <p className="customTextSmall is-required">{t("obligatorio")}</p>
                        <Steps
                          direction={"horizontal"}
                          responsive={false}
                          type="navigation"
                          size="small"
                          current={current}
                          onChange={onChange}
                          className="site-navigation-steps"
                        >
                          <Step title={t("registercenter.step1")} disabled={ current < 1} />
                          <Step title={t("registercenter.step2")} disabled={ current < 2} />
                          <Step title={t("registercenter.step3")} disabled={ current < 3} />
                        </Steps>
                      </div>
                    </>
                  )}

                  {current === 0 && (
                    <div data-id={'tab-register-'+current} className={"steps is-scrollable is-scrollable--center"}>
                      <StepOneCenter center={saveCenter} values={values} courses={courses} goTo={goTo} />
                    </div>
                  )}
                  {current === 1 && (
                    <div data-id={'tab-register-'+current} className={"steps is-scrollable is-scrollable--center"}>
                      <StepTwoCenter values={values} goTo={goTo} />
                    </div>
                  )}
                  {current === 2 && (
                    <div data-id={'tab-register-'+current} className={"steps is-scrollable is-scrollable--center"}>
                      <StepThreeCenter center={center} values={values} courses={courses} goTo={goTo} />
                    </div>
                  )}
                  {current === 3 && (
                    <div data-id={'tab-register-'+current} className={"steps is-scrollable is-scrollable--center-end"}>
                      <div className={"contratoEnviado"}>
                        <h3>{t("registercenter.contratoe")}</h3>
                        <p dangerouslySetInnerHTML={{__html: t("registercenter.subcontratoe")}} />
                        <Button
                          onClick={() => history.push("/default/index")}
                          type={"primary"}
                          className="primaryButton buttonSizeXXL"
                        >
                          {t("registro.gotoinicio")}
                        </Button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(RegisterCenter);
